import React, {useEffect, useState} from 'react'
import ModelContainer from '@core/scripts/components/model-container';
import ExternalDialogHistory from '@product/features/history/external-dialog';
import {intervalOver} from "../helper/interval.js";
import TrinityHelper from '@product/helper/trinity/trinity.ts';


const loadFlowbox = () => new Promise(resolve => {
    (function (d, id) {
        if (!window.flowbox) {
            const f = function () {
                f.q.push(arguments);
            };
            f.q = [];
            window.flowbox = f;
        }
        if (d.getElementById(id)) {
            return resolve();
        }
        const s = d.createElement('script'), fjs = d.scripts[d.scripts.length - 1];
        s.setAttribute('id', id);
        s.setAttribute('async', 'true');
        s.setAttribute('src', 'https://connect.getflowbox.com/flowbox.js');
        fjs.parentNode.insertBefore(s, fjs);
        resolve();

        ExternalDialogHistory.initById('flowbox', 'bzfy-feed-gate', function() {
            const node = document.querySelector('.bzfy-feed-gate-close-button');
            if (node) {
                node.click();
            }
        });
    })(document, 'flowbox-js-embed');
});

const getLocale = () => {
    const cid = window.bpMetaInfo?.['companyId'];
    return cid === '32' ? 'de-AT' : 'de-DE';
};

const flowboxSelector = '#pdp-flowbox';

export default function Flowbox({ product }) {

    const [loaded, setLoaded] = useState(false);
    const flowboxId = ModelContainer.get('flowboxId');

    if (flowboxId) {
        useEffect(() => {
            loadFlowbox().then(() => {
                window.flowbox('init', {
                    container: flowboxSelector,
                    key: flowboxId,
                    locale: getLocale(),
                    productId: product.currentItem.id,
                    allowCookies: false // https://help.getflowbox.com/en/articles/10006333-cookies-management-for-embed-flows
                });

                //flowbox is lazyly initialized, so we are waiting for the element to be in the viewport, analog to initializeFlow.js
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            observer.disconnect();
                            triggerPostprocessing(postProcessor);
                        }
                    })
                })
                observer.observe(document.querySelector(flowboxSelector));

            });
        }, []);

        function triggerPostprocessing(postProcessor) {
            //we need to wait until the flowbox is fully loaded and rendered
            intervalOver(2000, 100, (terminate) => {
                const flowboxDiv = document.querySelector(flowboxSelector);
                if (flowboxDiv && flowboxDiv?.reactRoot?._internalRoot?.current && flowboxDiv.querySelectorAll('.slick-slide').length > 0) {
                    terminate();
                    setLoaded(true);
                    postProcessor?.();
                }
            });
        }

        function postProcessor() {
            const elements = document.querySelectorAll(flowboxSelector + ' .slick-slide:not(.slick-cloned)');

            elements.forEach((element, index) => {
                element.onclick = () => handleCarousselElementClick();
            });

            if (elements.length > 0) {
                TrinityHelper.sendViewCarouselUgc(elements.length);
            }
        }

        function handleCarousselElementClick() {
            TrinityHelper.sendClickCarouselUgc();
            // we need to dynamically add the click event to the elements, because the flowbox modal is rendered the click
            intervalOver(2000, 100, (terminate) => {
                const modal = document.querySelector('#bzfy-modal-wrapper');
                if (modal) {
                    terminate();
                    modal.onclick = handleModalClickOnProduct;
                    modal.onkeydown = (e) => {
                        if (e.key === 'Enter') {
                            handleModalClickOnProduct(e);
                        }
                    };
                }
            });
        }

        function handleModalClickOnProduct(e) {
            const productContainer = e.target.closest('div.bzfy-gate-product');
            if (productContainer) {
                const querySelector = productContainer.querySelector('a.bzfy-gate-product-buy-button');
                const itemNumberMatch = querySelector?.href?.match(/.*\/(?:[a-z0-9\-]+-)?([0-9]{6,9})/);
                if (itemNumberMatch) {
                    const itemNumber = parseInt(itemNumberMatch[1], 10);
                    if (!isNaN(itemNumber)) {
                        TrinityHelper.sendClickLayerUgc(itemNumber);
                    }
                }
            }
            const currentProducts = document.querySelector('#pdp-flowbox').reactRoot?._internalRoot?.current?.child?.child?.child?.child?.child?.child?.child?.child?.child?.sibling?.sibling?.child?.child?.child?.pendingProps?.value?.currentProducts
            if (currentProducts && currentProducts.length > 0) {
                // products with href are loaded lazily after modal opens
                currentProducts.forEach((e) => {
                    const url = new URL(e.details.url);
                    url.searchParams.set('pointOfSaleLongId', '21');
                    e.details.url = url.toString();
                });
            }
        }

        return <>
            <div id='pdp-flowbox' className={'w-full product-recommendations-with-spacing'} />
        </>;
    }

    return <></>;
}